export enum UserRoleEnum {
  ADMIN = 'admin',
  GENERAL_MANAGER = 'general manager',
  CHEF = 'chef',
  MANAGER = 'manager',
  ACCOUNTANT = 'accountant',
  USER = 'user'
}
